import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Left Logo */}
      <img
        src="/aisleaiagents.png"
        alt="aisleaiagents"
        className="logo"
        onClick={() => navigate('/')}
        style={{
          cursor: 'pointer',
          position: 'absolute',
          top: '15px',      // Updated from CSS padding-top
          left: '20px',     // Updated from CSS padding-left
          height: '40px',   // Updated from CSS .logo-image height
          width: 'auto',    // Ensures aspect ratio is maintained
          zIndex: 10
        }}
      />

      {/* Right Logo */}
      <img
        src="/SLTMobitel_Logo.png"
        alt="SLTMobitel Logo"
        className="logo2"
        style={{
          cursor: 'pointer',
          position: 'absolute',
          top: '15px',      // Updated from CSS padding-top
          right: '20px',    // Updated from CSS padding-right
          height: '40px',   // Updated from CSS .logo-image height
          width: 'auto',    // Ensures aspect ratio is maintained
          zIndex: 10
        }}
      />
    </>
  );
};

export default Header;